import { render, staticRenderFns } from "./SportsForm.vue?vue&type=template&id=484cf5b8&"
import script from "./SportsForm.vue?vue&type=script&lang=js&"
export * from "./SportsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports